export default "__VITE_ASSET__BAsC4BUU__"